export type SrNameCandidate = {
    subject_id: number;
    name: string;
    name_eng?: string;
    name_reg?: string;
    mobile?: string;
    village?: string;
    request_count?: number;
};

export const normalizeNameCandidates = (raw: unknown): SrNameCandidate[] => {
    if (!Array.isArray(raw)) return [];
    return raw.filter(
        (c) => c && typeof (c as SrNameCandidate).subject_id === "number"
    ) as SrNameCandidate[];
};

export const selectionMessage = (c: SrNameCandidate) =>
    `Show service requests for subject_id=${c.subject_id} (${c.name})`;
